

















































import Vue, { PropType } from 'vue';
import { directive as onClickaway } from 'vue-clickaway';

export interface SelectOption<T extends string = string, E = any> {
    value: T;
    label: string;
    suffix?: string;
    search?: string;
    isCustom?: boolean;
    extra?: E;
}

export default Vue.extend({
    name: 'Select',
    directives: { onClickaway },
    props: {
        value: {
            type: String,
            required: true,
        },
        options: {
            type: Array as PropType<SelectOption[]>,
            required: true,
        },

        placeholder: {
            type: String,
            default: '',
        },

        disabled: Boolean,
        searchable: Boolean,
        custom: Boolean,
    },
    data() {
        return {
            open: false,
            query: '',
            selectedPlaceholder: '',
            selectedIndex: -1,
        };
    },
    computed: {
        filteredOptions(): SelectOption[] {
            if (!this.searchable) return this.options;

            const query = this.query.toLocaleLowerCase();
            return this.options.filter(o =>
                (o.search || o.label).toLocaleLowerCase().includes(query)
            );
        },
        selectedOption(): SelectOption | null {
            return this.options.find(option => option.value === this.value) || null;
        },
        selectedLabel(): string {
            return !!this.selectedOption ? this.selectedOption.label : '';
        },
    },
    methods: {
        away() {
            this.open = false;
        },
        scroll() {
            this.$nextTick(() => {
                const activeElement = this.$el.querySelector('div.option.active');
                if (!activeElement) return;

                activeElement.scrollIntoView({
                    block: 'center',
                });
            });
        },
        handleToggleInput(open?: boolean) {
            if (!this.open && this.disabled) return;

            this.open = typeof open !== 'undefined' ? open : !this.open;
        },
        handleSelectOption(option: SelectOption) {
            this.$emit('input', option.value, !!option.isCustom, this.options);
            this.open = false;
        },
        handleSelectCustom(label: string) {
            this.$emit('input', label, true, this.options);
            this.open = false;
        },
        handleKeyDown(evt: KeyboardEvent) {
            if (!this.open) {
                if (['ArrowDown', 'Enter'].includes(evt.key)) this.handleToggleInput();
                return;
            }
            switch (evt.key) {
                case 'ArrowUp':
                    this.selectedIndex = Math.max(-1, this.selectedIndex - 1);
                    this.scroll();
                    break;
                case 'ArrowDown':
                    this.selectedIndex = Math.min(
                        this.filteredOptions.length - 1,
                        this.selectedIndex + 1
                    );
                    this.scroll();
                    break;
                case 'Enter':
                    if (this.selectedIndex >= 0 && this.selectedIndex < this.filteredOptions.length)
                        this.handleSelectOption(this.filteredOptions[this.selectedIndex]);
                    else if (this.custom && !!this.query) this.handleSelectCustom(this.query);
                    break;
            }
        },
        handleInputBlur(evt: FocusEvent) {
            if (evt.relatedTarget === this.$el) return;

            if (this.custom && !!this.query) this.handleSelectCustom(this.query);
            else this.handleToggleInput(false);
        },
    },
    watch: {
        open(value: boolean) {
            if (this.searchable && value)
                this.$nextTick(() => {
                    const input = this.$el.querySelector('input');
                    if (input) input.focus();
                });
            else {
                this.query = '';
                this.selectedIndex = -1;
            }
        },
        selectedIndex(value: number) {
            const opt = this.filteredOptions[value];
            this.selectedPlaceholder = !!opt ? opt.label : '';
        },
        disabled(value: boolean) {
            if (value) this.open = false;
        },
    },
});
